export default __webpack_public_path__ + "static/media/maliha_story_2.b120da3d.jpg";